const EventBgColorsData = [
    {
        id: 1,
        eventtheme: "#EBD7CF",
    },
    {
        id: 2,
        eventtheme: "#D2BFDB",
    },
    {
        id: 3,
        eventtheme: "#B2E6C7",
    },
    {
        id: 4,
        eventtheme: "#FBF6B2",
    },
    {
        id: 5,
        eventtheme: "#CFEBD1",
    },
    {
        id: 6,
        eventtheme: "#BDE6EB",
    },
    {
        id: 7,
        eventtheme: "#CBCFDE",
    },
    {
        id: 8,
        eventtheme: "#EBC6BB",
    },
];
export default EventBgColorsData
